import axios from 'axios'
import { appConfig } from '../config'

axios.defaults.baseURL = appConfig.apiBaseUrl
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

export {
  axios
}
